import React, { useContext } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import {
  Calendar,
  Hashtag,
  Location,
  PersonIcon,
  RaindropIcon,
  ShipIcon,
  StateIcon,
  StockIcon,
} from '../../../../../../components/Svg'
import { corporateColor } from '../../../../../../theme/colors'
import { FuelContext } from '../../../../../../context/Logistics/fuel/FuelProvider'
import { DOBRA } from '../../../../../../theme/fonts'
import { useTranslation } from 'react-i18next'

export const Header = () => {
  const { form } = useContext(FuelContext)
  const { t } = useTranslation()

  return (
    <View style={style.container}>
      <View style={style.item}>
        <Hashtag height={25} width={25} />
        <Text style={style.label}>
          {t('N° pedido')}: {form.orderNumber}
        </Text>
      </View>
      <View style={style.item}>
        <Location height={25} width={25} />
        <Text style={style.label}>
          {t('Centro')}: {form.centerName}
        </Text>
      </View>

      <View style={style.item}>
        <Calendar height={25} width={25} />
        <Text style={style.label}>
          {t('Fecha de entrega')}: {form.deliveryDate}
        </Text>
      </View>

      <View style={style.item}>
        <PersonIcon height={25} width={25} />
        <Text style={style.label}>
          {t('Proveedor')}: {form.supplierName}
        </Text>
      </View>

      <View style={style.item}>
        <ShipIcon height={25} width={25} />
        <Text style={style.label}>
          {t('Embarcación')}: {form.shipName}
        </Text>
      </View>

      <View style={style.item}>
        <StockIcon height={25} width={25} />
        <Text style={style.label}>
          {t('Cantidad de litros')}: {form.meterNumber} lt
        </Text>
      </View>

      <View style={style.item}>
        <RaindropIcon height={25} width={25} />
        <Text style={style.label}>Pontón/Oxzo: {form.pontoonName}</Text>
      </View>

      <View style={style.item}>
        <StateIcon height={25} width={25} />
        {form.statusDetail && (
          <Text style={style.label}>
            {t('Estado')}: {Object.values(form.statusDetail!).pop()?.status}
          </Text>
        )}
      </View>
    </View>
  )
}

const style = StyleSheet.create({
  container: { padding: 24, gap: 8 },
  item: { flexDirection: 'row', gap: 8, alignItems: 'center' },
  label: {
    fontFamily: DOBRA,
    fontWeight: '400',
    fontSize: 16,
    lineHeight: 20,
    color: corporateColor,
  },
})
